import { render, staticRenderFns } from "./FilesModal.vue?vue&type=template&id=2339ac58&scoped=true"
import script from "./FilesModal.vue?vue&type=script&lang=js"
export * from "./FilesModal.vue?vue&type=script&lang=js"
import style0 from "./FilesModal.vue?vue&type=style&index=0&id=2339ac58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2339ac58",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/RoadSinisters/File/Lifting/FilesModal.vue
// module id = 665
// module chunks = 31